import type { ReactNode } from "react";
import { RequireAcl } from "@/components/RequireAcl";

/** Eigene Zeiterfassung – Berechtigung kommt vom Server-ACL (`/zeiterfassung.html`). */
export function RequireZeiterfassungAccess({ children }: { children: ReactNode }) {
  return <RequireAcl href="/zeiterfassung.html">{children}</RequireAcl>;
}

/** Admin-Zeiterfassung (alle Mitarbeiter) – separates ACL. */
export function RequireAdminZeiterfassungAccess({ children }: { children: ReactNode }) {
  return <RequireAcl href="/admin/zeiterfassung.html">{children}</RequireAcl>;
}
